module.exports = __webpack_public_path__ + "static/media/008.461ce71b.jpg";